module.exports = __webpack_public_path__ + "img/contact-info-grey.1d122c9a.svg";